import moment from 'moment'
import store from '../store';

export default class ContactModel {

  // default fields
  lastname = ''
  firstname = ''
  company = ''
  email = ''
  newsletter = false
  bounced = false
  phone = ''
  zipStreet = ''
  city = ''

  // more fields
  accountID = ''
  accountName = '' // disabled sort
  company2 = ''
  company3 = ''
  company4 = ''
  city2 = ''
  region = ''
  country = ''
  createdDateTime
  createdLabel = '' // NOTE: to be removed
  createdLabelSort = '' // NOTE: to be removed
  division = ''
  fax = ''
  homepage = ''
  id = ''
  mobile = ''
  modifiedDateTime
  modifiedLabel = '' // NOTE: to be removed
  modifiedLabelSort = '' // NOTE: to be removed
  poBox = ''
  position = ''
  zipPoBox = ''
  genderLabel = ''
  secondname = ''
  street = ''
  street2 = ''
  street3 = ''
  street4 = ''
  region = ''
  house_no = ''
  suid = '' // disabled sort
  // accountSUID = ''
  title = ''
  title2 = ''

  cmsLoginDateTime = ''
  pubLoginDateTime = ''

  // additional data
  creator = ''
  modified = false
  modifier = ''

  // categories
  categories = {}

  // custom fields
  customFields = {}

  // notices and resubmissions
  notices = []
  resubmissions = []

  // pictures
  pictures = []
  _duplicating = false

  mergedSUIDInfo = ''

  // FIXME: move all business logic out of the model
  mapAitemModified(aitem) {
    const LOCALE_DATE_FORMAT = store.getters.getLocaleDateFormat;

    let modifiedString = aitem.fields && aitem.fields.modification_date ? aitem.fields.modification_date._text || '' : ''
    let modifiedDateTime = modifiedString ? new Date(`${modifiedString.substr(0,4)}-${modifiedString.substr(4,2)}-${modifiedString.substr(6,2)} ${modifiedString.substr(-8)}`) : ''
    let modifiedDate = modifiedString ? moment(modifiedDateTime).format(LOCALE_DATE_FORMAT) : '' // NOTE: to be removed

    this.modifiedDateTime = modifiedDateTime
    this.modifiedLabel = modifiedDate // NOTE: to be removed
    this.modifiedLabelSort = modifiedString // NOTE: to be removed

    this.modifier = aitem.fields && aitem.fields.modifier && aitem.fields.modifier._attributes ? aitem.fields.modifier._attributes.name || '' : ''
  }

  // FIXME: move all business logic out of the model
  mapAitem(aitem) {
    // console.log(aitem)
    const LOCALE_DATE_FORMAT = store.getters.getLocaleDateFormat;
    let createdString = aitem.fields && aitem.fields.created ? aitem.fields.created._text || '' : ''
    let createdDateTime = createdString ? new Date(`${createdString.substr(0,4)}-${createdString.substr(4,2)}-${createdString.substr(6,2)} ${createdString.substr(-8)}`) : ''
    let createdDate = createdString ? moment(createdDateTime).format(LOCALE_DATE_FORMAT) : '' // NOTE: to be removed
    let modifiedString = aitem.fields && aitem.fields.modification_date ? aitem.fields.modification_date._text || '' : ''
    let modifiedDateTime = modifiedString ? new Date(`${modifiedString.substr(0,4)}-${modifiedString.substr(4,2)}-${modifiedString.substr(6,2)} ${modifiedString.substr(-8)}`) : ''
    let modifiedDate = modifiedString ? moment(modifiedDateTime).format(LOCALE_DATE_FORMAT) : '' // NOTE: to be removed

    let cmsLoginString = aitem.account && aitem.account.last_cms_login ? aitem.account.last_cms_login._text || '' : ''
    let cmsLoginDateTime = cmsLoginString ? new Date(`${cmsLoginString.substr(0,4)}-${cmsLoginString.substr(4,2)}-${cmsLoginString.substr(6,2)} ${cmsLoginString.substr(-8)}`) : ''
    let cmsLoginDate = cmsLoginString ? moment(cmsLoginDateTime).format(LOCALE_DATE_FORMAT) : '' // NOTE: to be removed
    let pubLoginString = aitem.account && aitem.account.last_pub_login ? aitem.account.last_pub_login._text || '' : ''
    let pubLoginDateTime = pubLoginString ? new Date(`${pubLoginString.substr(0,4)}-${pubLoginString.substr(4,2)}-${pubLoginString.substr(6,2)} ${pubLoginString.substr(-8)}`) : ''
    let pubLoginDate = pubLoginString ? moment(pubLoginDateTime).format(LOCALE_DATE_FORMAT) : '' // NOTE: to be removed

    // remap categories from aitem to appropriate object
    let cat_childs = aitem.categories && aitem.categories.cat ? (aitem.categories.cat.length ? aitem.categories.cat : [aitem.categories.cat]) : []
    let categories = {}
    for (let cat_child of cat_childs) {
      let cat = store.getters.getCategoryByChildId(cat_child._attributes.id)
      if (cat) {
        categories[cat.id] = categories[cat.id] || []
        categories[cat.id].push(cat_child._attributes.id)
        if (cat.multiple === '0') {
          categories[cat.id] = categories[cat.id].shift()
        }
      } else {
        store.commit('setShouldReloadData', true);
      }
    }

    // remap custom fields from aitem
    let ffs = aitem.freefields && aitem.freefields.ff ? (aitem.freefields.ff.length ? aitem.freefields.ff : [aitem.freefields.ff]) : []
    let customFields = {}
    for (let ff of ffs) {
      let custom_field = store.getters.getCustomFieldById(ff._attributes.id)
// console.log('custom_field: ', custom_field)
      if(custom_field.init_type == 2 && ff._text.length == 13) {
        customFields[custom_field.id] = ff._text + ':00'
      } else {
        customFields[custom_field.id] = ff._text
      }
      
    }

    // remap notices and resubmissions
    let notices = aitem.notices && aitem.notices.notice ? (aitem.notices.notice.length ? aitem.notices.notice : [aitem.notices.notice]) : []
    notices = notices.map(a => ({
      ...a._attributes,
      created: a._attributes.created ? new Date(`${a._attributes.created.substr(0,4)}-${a._attributes.created.substr(4,2)}-${a._attributes.created.substr(6,2)} ${a._attributes.created.substr(-8)}`) : '',
      modified: a._attributes.modified ? new Date(`${a._attributes.modified.substr(0,4)}-${a._attributes.modified.substr(4,2)}-${a._attributes.modified.substr(6,2)} ${a._attributes.modified.substr(-8)}`) : '',
      text: a._text
    }))
    let resubmissions = aitem.resubmissions && aitem.resubmissions.resubmission ? (aitem.resubmissions.resubmission.length ? aitem.resubmissions.resubmission : [aitem.resubmissions.resubmission]) : []
    resubmissions = resubmissions.map(a => ({
      ...a._attributes,
      created: a._attributes.created ? new Date(`${a._attributes.created.substr(0,4)}-${a._attributes.created.substr(4,2)}-${a._attributes.created.substr(6,2)} ${a._attributes.created.substr(-8)}`) : '',
      modified: a._attributes.modified ? new Date(`${a._attributes.modified.substr(0,4)}-${a._attributes.modified.substr(4,2)}-${a._attributes.modified.substr(6,2)} ${a._attributes.modified.substr(-8)}`) : '',
      text: a._text
    }))

    // default fields
    this.lastname = aitem.fields && aitem.fields.name ? aitem.fields.name._text || '' : ''
    this.firstname = aitem.fields && aitem.fields.first_name ? aitem.fields.first_name._text || '' : ''
    this.company = aitem.fields && aitem.fields.company ? aitem.fields.company._text || '' : ''
    this.email = aitem.fields && aitem.fields.email ? aitem.fields.email._text || '' : ''
    this.newsletter = aitem.fields && aitem.fields.newsletter ? aitem.fields.newsletter._text == 1 || false : false
    this.bounced = aitem.fields && aitem.fields.bounced ? aitem.fields.bounced._text == 1 || false : false
    this.phone = aitem.fields && aitem.fields.phone ? aitem.fields.phone._text || '' : ''
    this.zipStreet = aitem.fields && aitem.fields.zip_street ? aitem.fields.zip_street._text || '' : ''
    this.city = aitem.fields && aitem.fields.city ? aitem.fields.city._text || '' : ''

    // more fields
    this.accountID = aitem.fields && aitem.fields.user_id ? aitem.fields.user_id._text || '' : ''
    this.accountName = aitem.account && aitem.account.name ? aitem.account.name._text || '' : '' // disabled sort
    this.company2 = aitem.fields && aitem.fields.company2 ? aitem.fields.company2._text || '' : ''
    this.company3 = aitem.fields && aitem.fields.company3 ? aitem.fields.company3._text || '' : ''
    this.company4 = aitem.fields && aitem.fields.company4 ? aitem.fields.company4._text || '' : ''
    this.country = aitem.fields && aitem.fields.country ? aitem.fields.country._text || '' : ''
    this.createdDateTime = createdDateTime
    this.createdLabel = createdDate // NOTE: to be removed
    this.createdLabelSort = createdString // NOTE: to be removed
    this.division = aitem.fields && aitem.fields.division ? aitem.fields.division._text || '' : ''
    this.fax = aitem.fields && aitem.fields.fax ? aitem.fields.fax._text || '' : ''
    this.homepage = aitem.fields && aitem.fields.webpage ? aitem.fields.webpage._text || '' : ''
    this.id = aitem._attributes ? aitem._attributes.id || '' : ''
    this.mobile = aitem.fields && aitem.fields.mobile_extension ? aitem.fields.mobile_extension._text || '' : ''
    this.modifiedDateTime = modifiedDateTime
    this.modifiedLabel = modifiedDate // NOTE: to be removed
    this.modifiedLabelSort = modifiedString // NOTE: to be removed
    this.poBox = aitem.fields && aitem.fields.pobox ? aitem.fields.pobox._text || '' : ''
    this.position = aitem.fields && aitem.fields.position ? aitem.fields.position._text || '' : ''
    this.zipPoBox = aitem.fields && aitem.fields.zip_pobox ? aitem.fields.zip_pobox._text || '' : ''
    this.genderLabel = aitem.fields && aitem.fields.gender ? aitem.fields.gender._text || '' : ''
    this.secondname = aitem.fields && aitem.fields.second_name ? aitem.fields.second_name._text || '' : ''
    this.street = aitem.fields && aitem.fields.street ? aitem.fields.street._text || '' : ''
    this.street2 = aitem.fields && aitem.fields.street2 ? aitem.fields.street2._text || '' : ''
    this.street3 = aitem.fields && aitem.fields.street3 ? aitem.fields.street3._text || '' : ''
    this.street4 = aitem.fields && aitem.fields.street4 ? aitem.fields.street4._text || '' : ''
    this.suid = aitem._attributes ? aitem._attributes.suid || '' : '' // disabled sort
    // accountSUID: aitem.account && aitem.account._attributes ? aitem.account._attributes.suid || '' : ''
    this.title = aitem.fields && aitem.fields.title ? aitem.fields.title._text || '' : ''
    this.title2 = aitem.fields && aitem.fields.title2 ? aitem.fields.title2._text || '' : ''

    this.house_no = aitem.fields && aitem.fields.house_no ? aitem.fields.house_no._text || '' : ''
    this.city2 = aitem.fields && aitem.fields.city2 ? aitem.fields.city2._text || '' : ''
    this.region = aitem.fields && aitem.fields.region ? aitem.fields.region._text || '' : ''

    this.cmsLoginDateTime = cmsLoginDateTime,
    this.cmsLoginLabel = cmsLoginDate, // NOTE: to be removed
    this.cmsLoginLabelSort = cmsLoginString, // NOTE: to be removed
    this.pubLoginDateTime = pubLoginDateTime,
    this.pubLoginLabel = pubLoginDate, // NOTE: to be removed
    this.pubLoginLabelSort = pubLoginString, // NOTE: to be removed

    // additional data
    this.creator = aitem.fields && aitem.fields.creator && aitem.fields.creator._attributes ? aitem.fields.creator._attributes.name || '' : ''
    this.modified = aitem.fields && aitem.fields.modified ? aitem.fields.modified._text == 1 || false : false
    this.modifier = aitem.fields && aitem.fields.modifier && aitem.fields.modifier._attributes ? aitem.fields.modifier._attributes.name || '' : ''

    // categories
    this.categories = categories

    // custom fields
    this.customFields = customFields

    // notices and resubmissions
    this.notices = notices.sort((a, b) => b.modified.getTime() - a.modified.getTime())
    this.resubmissions = resubmissions.sort((a, b) => b.modified.getTime() - a.modified.getTime())
    // this.noticesAndResubmissions = notices.map(a => ({ ...a, _type: 'notice'})).concat(resubmissions.map(a => ({ ...a, _type: 'resubmission'}))).sort((a, b) => b.modified.getTime() - a.modified.getTime())

    // pictures
    let pictures = aitem.pictures && aitem.pictures.picture ? (aitem.pictures.picture.length ? aitem.pictures.picture : [aitem.pictures.picture]) : []
    pictures = pictures.map(a => ({ ...a._attributes, content: a._cdata ? a._cdata : a._text }))
    this.pictures = pictures

    let suids = aitem.merged && aitem.merged.suid ? aitem.merged.suid : null
    suids = Array.isArray(suids) ? suids : []
    this.mergedSUIDInfo =  suids.map(s => s._text).join('\n')

    return this
  }

}
